import { getApiBaseUrl } from './apiBase';

// organizations.logo_path is stored relative to the backend root, without a
// leading slash or host (e.g. "uploads/organization/logo/logo-123.png").
// Build the full URL in one place so every shell (Org Admin, Manager,
// Learner, Master) resolves it the same way.
export const orgLogoUrl = (logoPath) => {
  if (!logoPath) return '';
  if (/^(https?:|data:)/i.test(logoPath)) return logoPath;

  const base = String(getApiBaseUrl() || '').replace(/\/api\/?$/, '');
  return `${base}/${String(logoPath).replace(/^\/+/, '')}`;
};

export default orgLogoUrl;